import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components';
import css from './ContactPreFooter.css';

import imgCEO from '../../assets/pro-miikka-salminen.webp';

const ContactPreFooter = () => {
  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  return (
    <div className={css.root}>
      <div className={css.container}>
        <div className={css.content}>
          <div className={css.contactCard}>
            <div className={css.cardBackground} />
            <div className={css.avatarContainer}>
              <img src={imgCEO} alt="Miikka Salminen" className={css.avatar} />
            </div>
            <p className={css.name}>Miikka Salminen, CEO</p>
            <div className={css.contactInfo}>
              <p>miikka@freedomly.io</p>
              <p>+358 45 268 2218</p>
            </div>
            <ExternalLink className={css.button} onClick={handleShowSpaceHome}>
              <FormattedMessage id="ContactPreFooter.buttonText" />
            </ExternalLink>
          </div>
          <div className={css.textContent}>
            <h2 className={css.title}>
              <FormattedMessage id="ContactPreFooter.title" />
            </h2>
            <p className={css.description}>
              <FormattedMessage id="ContactPreFooter.description" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPreFooter;
